export default "__VITE_ASSET__DfQc8Wzi__"